import type { CSSProperties } from 'react'
import type { ToasterProps } from 'sonner'

import { Toaster as Sonner } from 'sonner'

import {
    CircleCheckIcon,
    InfoIcon,
    Loader2Icon,
    OctagonXIcon,
    TriangleAlertIcon
} from 'lucide-react'

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme='light'
            className='toaster group'
            icons={{
                success: <CircleCheckIcon className='size-4' />,
                info: <InfoIcon className='size-4' />,
                warning: <TriangleAlertIcon className='size-4' />,
                error: <OctagonXIcon className='size-4' />,
                loading: <Loader2Icon className='size-4 animate-spin' />
            }}
            style={
                {
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                    '--border-radius': 'var(--radius)'
                } as CSSProperties
            }
            toastOptions={{
                classNames: {
                    toast: 'cn-toast'
                }
            }}
            {...props}
        />
    )
}

export { Toaster }
